module.exports = __webpack_public_path__ + "static/promo-bg-5502dcafc0ad47ae623a71a5e9aa5f11.png";